import { IResult } from './IResult'
import { AbstractSearchCore } from './AbstractSearchCore'
import { AbstractSubscriber } from './AbstractSubscriber'
import { IFacet } from './IFacet'
import { ISearchConfig } from './ISearchConfig'
import { MultipleResults } from './result'

export class SearchResultsSubscriber extends AbstractSubscriber {
  core: AbstractSearchCore | undefined
  onResultUpdateCallback: (result: IResult | MultipleResults) => void
  onSearchConfigUpdateCallback: (searchConfig: ISearchConfig) => void
  onReadyCallback: () => void = () => {}
  constructor(
    groupId: string,
    onResultUpdateCallback: (result: IResult | MultipleResults) => void,
    onSearchConfigUpdateCallback: (searchConfig: ISearchConfig) => void,
    onReadyCallback?: () => void
  ) {
    super(groupId)
    this.onResultUpdateCallback = onResultUpdateCallback
    this.onSearchConfigUpdateCallback = onSearchConfigUpdateCallback
    if (onReadyCallback) this.onReadyCallback = onReadyCallback
  }
  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this.core = searchCore
    this.onReadyCallback?.()
  }

  public async doSearch(searchConfig: ISearchConfig) {
    await this.core?.executeSearch(searchConfig)
  }

  // change page based on the index and page number, useful for pagination between different search index.
  public async changePage(index: string, page: number): Promise<void> {
    await this.core?.applySearchConfig(
      {
        options: {
          page: {
            [index]: page,
          },
        },
      } as ISearchConfig,
      false
    )
    await this.core?.goToSearch(false)
  }

  public async resetPage(index: string): Promise<void> {
    await this.core?.applySearchConfig(
      {
        options: {
          page: {
            [index]: 0,
          },
        },
      } as ISearchConfig,
      false
    )
  }

  public async openModal(modalName: string): Promise<void> {
    await this.core?.applySearchConfig(
      {
        modal: modalName,
      } as ISearchConfig,
      false
    )
    await this.core?.goToSearch(false)
  }

  public async goToMainSearchResults(): Promise<void> {
    await this.core?.applySearchConfig(
      {
        modal: null,
        page: 0,
      },
      false
    )
    await this.core?.goToSearch()
  }

  public async onResultUpdate(result: IResult | MultipleResults): Promise<void> {
    this.onResultUpdateCallback(result)
  }

  public setPage(pageNumber: number) {
    this.core?.setPage(pageNumber)
  }

  public clearFacet(filterName: string) {
    this.core?.clearFacet(filterName)
  }

  public applyAudienceFilters(filters: IFacet[]) {
    this.core?.applyMultipleFacets(filters)
  }

  public async selectSortingOption(modal: string, sortingOption: string): Promise<void> {
    await this.core?.applySearchConfig(
      {
        query: '',
        modal: modal,
        page: 0,
        sorting: sortingOption,
      },
      false
    )
    this.core?.goToSearch()
  }

  detaching(): void {}

  onSearchConfigUpdate(searchConfig: ISearchConfig): Promise<void> {
    this.onSearchConfigUpdateCallback(searchConfig)
    return Promise.resolve(undefined)
  }

  onFacetUpdate(facets: IFacet[]): Promise<void> {
    return Promise.resolve(undefined)
  }

  onSearchTextUpdate(text: string): Promise<void> {
    return Promise.resolve(undefined)
  }
}
